var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersDeep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.464 15.464A5 5 0 015 14h8a5 5 0 015 5v2a1 1 0 11-2 0v-2a3 3 0 00-3-3H5a3 3 0 00-3 3v2a1 1 0 11-2 0v-2a5 5 0 011.464-3.536zM9 4a3 3 0 100 6 3 3 0 000-6zM4 7a5 5 0 1110 0A5 5 0 014 7z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.032 14.88a1 1 0 011.218-.718A5 5 0 0124 18.999V21a1 1 0 11-2 0v-2a3 3 0 00-2.25-2.902 1 1 0 01-.718-1.218zM15.031 2.882a1 1 0 011.217-.72 5 5 0 010 9.687 1 1 0 01-.496-1.938 3 3 0 000-5.812 1 1 0 01-.72-1.217z",
    fill: "#000",
    fillOpacity: 0.45
  })));
}
export default SvgUsersDeep;